// Browser-compatible JWT utilities
// We don't store any secrets in the frontend code
// All token generation and validation should be done by the backend



/**
 * Base64 URL decode a string
 * @param str The string to decode
 * @returns The decoded string
 */
const base64UrlDecode = (str: string): string => {
  // Add padding if needed
  str = str.replace(/-/g, '+').replace(/_/g, '/');
  while (str.length % 4) {
    str += '=';
  }
  return atob(str);
};

/**
 * Decode a JWT token
 * @param token The token to decode
 * @returns The decoded token payload
 */
const decodeToken = (token: string): any | null => {
  try {
    // Split the token into parts
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('Invalid token format');
      return null;
    }

    // Decode the payload
    return JSON.parse(base64UrlDecode(parts[1]));
  } catch (error) {
    console.error('JWT decode error:', error);
    return null;
  }
};

/**
 * Check if a JWT token is expired
 * @param token The token to check
 * @returns The decoded token payload if not expired, null otherwise
 */
export const verifyToken = (token: string): any | null => {
  try {
    // Decode the token
    const payload = decodeToken(token);
    if (!payload) {
      return null;
    }

    // Check if the token is expired
    const now = Math.floor(Date.now() / 1000);
    if (payload.exp && payload.exp < now) {
      console.error('Token expired');
      return null;
    }

    return payload;
  } catch (error) {
    console.error('JWT verification error:', error);
    return null;
  }
};
